import { render } from "./Section2.vue?vue&type=template&id=21392f37&scoped=true"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"

import "./Section2.vue?vue&type=style&index=0&id=21392f37&lang=scss&scoped=true"
import "./Section2.vue?vue&type=style&index=1&id=21392f37&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21392f37"]])

export default __exports__